'use client';
import React from 'react';
import { GitBranch } from 'lucide-react';

interface GenData {
  gen: string;
  label: string;
  execCount: number;
  gsv: number;
  bonusPct: number;
  bonus: number;
  isBreakaway: boolean;
}

export default function GenerationBottomPanel({ generationData }: { generationData: GenData[] }) {
  const totalBonus = generationData.reduce((s, g) => s + g.bonus, 0);

  return (
    <div className="h-full flex flex-col">
      <div className="flex items-center justify-between px-4 py-2.5 border-b border-zinc-800 flex-shrink-0">
        <div className="flex items-center gap-2">
          <GitBranch size={13} className="text-violet-400" />
          <span className="text-xs font-semibold text-zinc-400 uppercase tracking-wider">Generation Commission Summary (G1–G6)</span>
        </div>
        <span className="text-xs font-bold text-emerald-400 font-mono">${totalBonus.toFixed(0)} total</span>
      </div>
      <div className="flex-1 overflow-x-auto scrollbar-thin">
        <table className="w-full">
          <thead>
            <tr className="border-b border-zinc-800">
              {['Gen', 'Execs', 'GSV', 'Bonus %', 'Breakaway', 'Commission'].map(h => (
                <th key={`gen-th-${h}`} className="text-left text-[9px] font-semibold uppercase tracking-wider text-zinc-600 px-3 py-1.5 whitespace-nowrap">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {generationData.map(g => (
              <tr key={`gen-row-${g.gen}`} className="border-b border-zinc-800/40 hover:bg-zinc-800/20 transition-colors">
                <td className="px-3 py-1.5">
                  <span className="text-xs font-bold text-violet-400 font-mono">{g.gen}</span>
                </td>
                <td className="px-3 py-1.5">
                  <span className="text-xs text-zinc-300 font-mono">{g.execCount}</span>
                </td>
                <td className="px-3 py-1.5">
                  <span className="text-xs text-zinc-300 font-mono">{(g.gsv/1000).toFixed(1)}K</span>
                </td>
                <td className="px-3 py-1.5">
                  <span className={`text-xs font-semibold font-mono ${g.bonusPct === 5 ? 'text-emerald-400' : 'text-amber-400'}`}>{g.bonusPct}%</span>
                </td>
                <td className="px-3 py-1.5">
                  <span className={`text-[10px] font-semibold px-1.5 py-0.5 rounded ${g.isBreakaway ? 'bg-violet-500/15 text-violet-400' : 'bg-zinc-700/40 text-zinc-500'}`}>
                    {g.isBreakaway ? 'Yes' : 'No'}
                  </span>
                </td>
                <td className="px-3 py-1.5">
                  <span className="text-xs font-bold text-emerald-400 font-mono">${g.bonus.toFixed(0)}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}